module.exports = __webpack_public_path__ + "static/media/fleche-gauche-cercle.3345a681.png";